import React from 'react';
import { ReactComponent as DownloadIcon } from '../../icons/download.svg';
import SidewaysLoading from './sidebar/SidewaysLoading';

interface ProDocDownloadButtonProps {
  onClick: () => void;
  processing?: boolean;
}

const ProDocDownloadButton: React.FC<ProDocDownloadButtonProps> = ({
  onClick,
  processing = false,
}) => {
  return (
    <div className={`button-wrapper ${processing ? 'processing' : ''}`}>
      <button
        className='pro-doc-download-button'
        onClick={onClick}
        title='Download ProDoc'
        disabled={processing}
      >
        <DownloadIcon />
        {processing && <SidewaysLoading />}
      </button>
    </div>
  );
};

export default ProDocDownloadButton;
